import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cros/page.tsx");
